module.exports = __webpack_public_path__ + "static/media/orange-bottle.6d4c9776.svg";